








export default {
    name: 'NotFound'
};
